export default __webpack_public_path__ + "static/media/about-thumb-1-challenge.26b7cc78.webp";